import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { CapsuleGroup } from '@/tools/manualCondition/CapsuleGroup';

import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { CapsuleGroupCapsule } from '@/tools/manualCondition/manualCondition.constants';

export interface CapsuleGroupIF extends ValidatingFormComponent<CapsuleGroupCapsule[]> {
  component: 'CapsuleGroupFormComponent';
  previewId: string;
  autoUpdateDate?: boolean;
}

export const CapsuleGroupFormComponent = (props: CapsuleGroupIF) => {
  const {
    name,
    testId = 'capsuleGroup',
    wrapperClassNames = '',
    wrapperXstyle,
    label,
    validation,
    extendValidation,
    customErrorText,
    previewId,
    value,
    autoUpdateDate,
  } = props;

  const defaultValidation = () => !value || !_.isArray(value) || value.length === 0;

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && formState.touched?.[name];

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      showError={showError}
      customErrorText={customErrorText}
      wrapperClassNames={wrapperClassNames}
      wrapperXstyle={wrapperXstyle}>
      <Field name={name} validate={appliedValidation}>
        {() => {
          return <CapsuleGroup previewId={previewId} autoUpdateDate={autoUpdateDate} />;
        }}
      </Field>
    </FormFieldWrapper>
  );
};
